import { Action } from '@ngrx/store';
import { FlybackReducer } from '../models/flyback-reducer.model';

export interface ActionWithPayloadInterface extends Action {
  payload: any;
}

export const UPDATE_FLYBACK_ELIGIBLE_PRODUCTS = 'UPDATE_FLYBACK_ELIGIBLE_PRODUCTS';
export const UPDATE_FLYBACK_REDIRECT = 'UPDATE_FLYBACK_REDIRECT';
export const FLY_BACK_FLIGHT_DATE = 'FLY_BACK_FLIGHT_DATE';
export const UPDATE_CURRENT_STEP = 'UPDATE_CURRENT_STEP';
export const DECREMENT_CURRENT_STEP = 'DECREMENT_CURRENT_STEP';
export const UPDATE_FLIGHT_QUOTE = 'UPDATE_FLIGHT_QUOTE';
export const UPDATE_FLYBACK_BOOKING_STATUS = 'UPDATE_FLYBACK_BOOKING_STATUS';
export const SET_FLYBACK_MIN_PRICE = 'SET_FLYBACK_MIN_PRICE';
export const UPDATE_FLYBACK_CUSTOMER_DETAILS = 'UPDATE_FLYBACK_CUSTOMER_DETAILS';
export const UPDATE_FLYBACK_CUSTOMER_HAS_MARKETING_ENROLMENT = 'UPDATE_FLYBACK_CUSTOMER_HAS_MARKETING_ENROLMENT';
export const UPDATE_FLY_BACK_COMPLETE_STATUS = 'UPDATE_FLY_BACK_COMPLETE_STATUS';
export const UPDATE_FLYBACK_MIN_DATE = 'UPDATE_FLYBACK_MIN_DATE';
export const REFRESH_FLYBACK_REDUCER = 'REFRESH_FLYBACK_REDUCER';
export const RESET_OPTIONAL_DATA_FLYBACK_REDUCER = 'RESET_OPTIONAL_DATA_FLYBACK_REDUCER';
export const RESET_FLYBACK_REDUCER = 'RESET_FLYBACK_REDUCER'; //TODO: reset reducer after booking confirmation
export const UPDATE_FLYBACK_PROMO_FROM_URL = 'UPDATE_FLYBACK_PROMO_FROM_URL';
export const UPDATE_FLYBACK_CS_MOTO_FROM_URL = 'UPDATE_FLYBACK_CS_MOTO_FROM_URL';

const optinalDataInitState = {
  flybackBooking: false,
  flyBackRedirect: false,
  currentStep: 0,
  outboundPrice: '',
  inboundPrice: '',
  departurePostOfficePrice: '',
  promoFromUrl: null,
  csMotoFromUrl: false,
}

const initState: FlybackReducer = {

  eligibleProducts: null,
  abcAvailable: false,
  ccdAvailable: false,

  quoteFlightRequest: {
    departureAirport: null,
    toAirport: null,
    toCity: null,
    arrivalAirport: null,
    fromAirport: null,
    fromCity: null,
    airline: null,
    airlineName: null,
    departDate: null,
    bagCount: null,
    bagItems: {
      bags: 0,
      childEquipment: 0,
      oversizeItem: 0
    },
    flightDirection: null,
    flightNumber: null,
    optedInViaPod: false,
  },

  customerDetails: {
    firstName: '',
    lastName: '',
    emailAddress: ''
  },
  isFlybackCompleted: false,
  flybackMinDate: '',
  flybackFlightDate: '',
  ...optinalDataInitState
}


export function flybackReducer(state = initState, action: ActionWithPayloadInterface) {
  switch (action.type) {

    case UPDATE_FLYBACK_ELIGIBLE_PRODUCTS:
      return Object.assign({}, state, { eligibleProducts: action.payload, abcAvailable: action.payload.includes('ABC'), ccdAvailable: action.payload.includes('CCD') });

    case FLY_BACK_FLIGHT_DATE:
      return Object.assign({}, state, { flybackFlightDate: action.payload });

    case UPDATE_CURRENT_STEP:
      return Object.assign({}, state, { currentStep: state.currentStep + 1 });

    case DECREMENT_CURRENT_STEP:
      return Object.assign({}, state, { currentStep: state.currentStep - 1 });

    case UPDATE_FLIGHT_QUOTE:
      return Object.assign({}, state, { quoteFlightRequest: action.payload });

    case UPDATE_FLYBACK_BOOKING_STATUS:
      return Object.assign({}, state, { flybackBooking: action.payload });

    case UPDATE_FLYBACK_REDIRECT:
      return Object.assign({}, state, { flyBackRedirect: action.payload });

    case UPDATE_FLYBACK_CUSTOMER_DETAILS:
      return Object.assign({}, state, { customerDetails: action.payload });

    case UPDATE_FLYBACK_CUSTOMER_HAS_MARKETING_ENROLMENT:
      return Object.assign({}, state, { customerHasMarketingEnrolment: action.payload });

    case UPDATE_FLY_BACK_COMPLETE_STATUS:
      return Object.assign({}, state, { isFlybackCompleted: action.payload });

    case SET_FLYBACK_MIN_PRICE:
      return Object.assign({}, state, { ...action.payload });

    case UPDATE_FLYBACK_MIN_DATE:
      return Object.assign({}, state, { flybackMinDate: action.payload });

    case UPDATE_FLYBACK_PROMO_FROM_URL:
      return Object.assign({}, state, { promoFromUrl: action.payload });

    case UPDATE_FLYBACK_CS_MOTO_FROM_URL:
      return Object.assign({}, state, { csMotoFromUrl: action.payload });

    case RESET_OPTIONAL_DATA_FLYBACK_REDUCER:
      return Object.assign({}, state, { ...optinalDataInitState });

    case REFRESH_FLYBACK_REDUCER:
      return Object.assign({}, action.payload);

    case RESET_FLYBACK_REDUCER:
      return Object.assign({}, initState);

    default:
      return state;
  }
}
